import { shallow } from "zustand/shallow";

import { topLevelListingsSchema } from "@hsl/fund-explorer/metaSchemas";

import { generateLocalId } from "../store/helpers";
import useExplorerStore from "../store/store";
import useShareClassData from "./useShareClassData";

function useListingsData(shareClasses: string[]) {
    const { getDataById, listings } = useExplorerStore(
        ({ getDataById, refinedData: { listings } }) => ({
            getDataById,
            listings,
        }),
        shallow,
    );
    const shareClassData = useShareClassData(shareClasses);
    return Object.fromEntries(
        shareClassData.map((shareClass) => [
            shareClass.data.shortName,
            (shareClass.listings || [])
                .map(generateLocalId("listing"))
                .filter((l) => listings.includes(l))
                .map((id) => {
                    const listingData = getDataById(id);
                    // const dataWithListingDate = {
                    //     ...listingData,
                    //     data: {
                    //         ...listingData?.data,
                    //         // listingDate: shareClass.data.launchDate,
                    //     },
                    // };
                    return topLevelListingsSchema.parse(listingData);
                }),
        ]),
    );
}

export default useListingsData;
